import {
  State as ViewerState,
  ViewerApi,
} from '@swd_admin/cdc-viewer';
import create from 'zustand';

type ViewerStateContext = {
  viewer: ViewerApi | undefined;
  viewerState: ViewerState | undefined;
  subscriptions: Array<Function>;
  setViewer: (viewer: ViewerApi | undefined) => void;
  setViewerState: (s: ViewerState) => void;
  addSubscription(unSub: Function): void;
  clearSubscriptions: () => void;
};

export const useViewerState = create<ViewerStateContext>((set, get) => ({
  viewer: undefined,
  viewerState: undefined,
  subscriptions: [],
  addSubscription: (unSub) =>
    set((state) => ({
      subscriptions: [...state.subscriptions, unSub],
    })),
  clearSubscriptions: () => {
    get().subscriptions.forEach((unSub) => {
      unSub();
    });
    set(() => ({ subscriptions: [] }));
  },
  setViewer: (viewer: ViewerApi | undefined) =>
    set(() => ({
      viewer,
    })),
  setViewerState: (s: ViewerState) => set(() => ({ viewerState: s })),
}));
